module.exports = __webpack_public_path__ + "static/media/silkycloud-gold-5.1e6444d9.png";